// extracted by mini-css-extract-plugin
export default {"row":"layout_row__bSafZ","row-wrap":"layout_row-wrap__HqCDs","column":"layout_column__kf1rB"};